export const routeConfig = {
  meta: {
    active: '2',
  },
};
